<template>
  <div>
    <el-table :data="projectList" height="calc(100vh - 360px)">
      <el-table-column label="创建时间">
        <template slot-scope="scope">{{
          scope.row.createTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="blockHash" label="区块Hash"></el-table-column>
      <el-table-column
        prop="blockNumberOrPosition"
        label="区块高度"
      ></el-table-column>
      <el-table-column label="区块时间">
        <template slot-scope="scope">{{
          scope.row.blockTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="amount" label="数量"></el-table-column>
      <el-table-column prop="coin" label="币种"></el-table-column>
      <el-table-column
        prop="disposeStatusInner"
        label="内部状态"
      ></el-table-column>
      <el-table-column prop="finished" label="完成状态">
        <template slot-scope="scope">{{
          scope.row.finished ? '已处理' : '未处理'
        }}</template>
      </el-table-column>
      <el-table-column
        prop="fromAccountOrAddress"
        label="from地址"
      ></el-table-column>
      <el-table-column prop="hash" label="hash"></el-table-column>
      <el-table-column label="to地址">
        <template slot-scope="scope">
          <a class="link" target="_blank">{{ scope.row.toAddress }}</a>
          <!-- <a
            class="link"
            target="_blank"
            @click="open(scope.row.coin, scope.row.toAddress, scope.row.hash)"
            >{{ scope.row.toAddress }}</a
          > -->
        </template>
      </el-table-column>
      <el-table-column label="审核状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color">{{
            scope.row.__status.text
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="区块状态"></el-table-column>

      <el-table-column label="操作" width="250px">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="cancelBlack(true, scope.row.id)"
            v-if="scope.row.auditStatus === 0"
            >审核通过</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click="cancelBlack(false, scope.row.id)"
            v-if="scope.row.auditStatus === 0"
            >审核不通过</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'

export default {
  name: 'KYCAudit',
  data() {
    return {
      auditId: null,
    }
  },
  computed: {
    ...mapState('deposite', ['pagination', 'totalCount', 'auditList']),
    ...mapGetters('deposite', ['projectList']),
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('deposite', ['list', 'setPass']),
    ...mapMutations('deposite', ['setpage']),
    handleCurrentChange(pagination) {
      this.setpage(pagination)
      this.$emit('refresh', { pagination, type: 1 })
    },
    cancelBlack(isPass, id) {
      const action = isPass
        ? this.$confirm('确定通过审核吗？', '提示', {
            type: 'warning',
          })
        : this.$confirm('确定审核不通过吗？', '提示', {
            type: 'warning',
          })
      action.then(({ value }) => {
        this.setPass({
          id: id,
          auditStatus: isPass ? 1 : 2,
        })
          .then(() => {
            this.$message({
              type: 'success',
              message: '操作成功！',
            })
          })
          .finally(() => {
            this.list({ page: 1 })
          })
      })
    },
    open(coin, toAddress, hash) {
      window.open(
        '#/home/audit/deposite/records?coin=' +
          coin +
          '&toAddress=' +
          toAddress +
          '&hash=' +
          hash
      )
    },
  },
}
</script>

<style lang="less" scoped>
.link {
  text-decoration: underline;
  cursor: pointer;
  color: #409eff;
}
</style>
